exports = module.exports = require("../../../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table[data-v-9c3ac7cc]{border-collapse:collapse\n}\n.isOrderItem td[data-v-9c3ac7cc]{padding-top:8px;padding-bottom:8px\n}\n.isGoodItem td[data-v-9c3ac7cc]{min-height:60px\n}\n", ""]);

// exports
